'use client';

import { useEffect } from 'react';

import { recordScan } from '../utils/api/campaign';

export default function ScanCounter(props: { qrId: string }) {
  useEffect(() => {
    const scan = sessionStorage.getItem(`scan:${props.qrId}`);
    if (!scan) {
      void recordScan(props.qrId);
      sessionStorage.setItem(`scan:${props.qrId}`, Date.now().toString());
    }
  }, [props.qrId]);

  return null;
}
